/**
 * @prettier
 * @flow
 */
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PushPosEmulatorPageV1 } from 'src/scenes/PushPosEmulatorPageV1';
import { VersionPage } from 'src/scenes/VersionPage';
import { PushPosEmulatorPage } from 'src/scenes/PushPosEmulatorPage';

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    layout: {
        width: 'auto',
        height: '100%',
    },
}));

export function App() {
    const classes = useStyles();

    const showVersionsPage = urlEndsWithVersions();
    if (showVersionsPage) {
        return <main className={classes.layout}>
            <VersionPage />
        </main>;
    }

    return <main className={classes.layout}>
        <Switch>
            <Route path="/v2">
                <PushPosEmulatorPage />
            </Route>
            <Route path="/">
                <PushPosEmulatorPageV1 />
            </Route>
        </Switch>
    </main>;
}

function urlEndsWithVersions() {
    return window.location.pathname.match(/\/version$/)?.[0];
}
